export function abbreviateStockTypeUnit(value) {
  if (!value) return value;
  switch (value.toLowerCase()) {
    case 'tray': return 'T';
    case 'dozen': return 'd';
    case 'eighteen': return 's';
    case 'each': return '';
    default: return value;
  }
}

export function unitToDisplayText(value) {
  if (!value) return value;
  switch (value.toLowerCase()) {
    case 'tray': return '- Trays';
    case 'dozen': return '- Doz';
    case 'eighteen': return ` - 18's - Single`;
    case 'each': return '';
    default: return value;
  }
}



// WEBPACK FOOTER //
// ./src/layer/filters/units.js